import React from "react";

import LakeUnion from "./../../images/Lake_Union_Loop_thumbnail.jpg";
import EmeraldCity from "./../../images/Emerald_City_Tour_thumbnail.jpg";
import ScenicTour from "./../../images/IMG_6683.jpg";

// import mapSVG from "./../../images/map.svg";
import clockSVG from "./../../images/time.svg";


const Tours = () => (
  <div className="bg-brand-white flex justify-around py-8" id="tours">
    <div className="w-5/6 max-w-2xl ml-auto mr-auto my-8"  data-aos="fade" data-aos-duration="1200" data-aos-delay="300" data-aos-once="true">
      <div className="flex flex-row justify-center flex-wrap">

        <div className="max-w-xs m-2 rounded flex-auto overflow-hidden shadow-lg flex flex-col">
          <img className="w-full flex-grow" src={LakeUnion} alt="A photo of the Lake Union tour showing the view of South Lake Union from Gasworks Park. "></img>
          <div className="px-6 py-4 flex-grow">
            <div className="font-bold text-xl mb-2 uppercase font-title">Lake Union Loop</div>
            <p className="text-grey-darker text-base leading-normal font-body pt-4 pr-4 pb-4">
            Circumnavigate beautiful Lake Union! Located inside Seattle’s city limits at the north end of downtown, Lake Union is at the heart of Seattle’s history and culture. This tour explores the distinctive lakeside neighborhoods and pauses along the way to sample local craft coffee, chocolate, and beer. 
            </p>
          </div>

          <div className="p-8 bg-grey-lightest flex-grow">
            <div className="flex pb-2">
              <svg className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z"/>
              </svg>
              <p className="font-body text-base ml-2">Difficulty: <span className="text-green font-bold">Easy</span> to <span className="text-orange font-bold">Moderate</span>
              </p>
            </div>
            <div className="flex pb-2">
              <svg className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41L9 10.41z"/>
              </svg>
              <p className="font-body text-base ml-2">Start Time: <span className="font-bold">11AM</span> 
              </p>
            </div>
            <div className="flex pb-2">
              <svg className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M0 0l20 8-8 4-2 8z"/>
              </svg>
              <p className="font-body text-base ml-2">70% Bike Path
              </p>
            </div>
            <div className="flex pb-2">
              <svg className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M2 14v-3H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1l4-7h8l4 7h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3zm13.86-5L13 4H7L4.14 9h11.72zM5.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
              </svg>
              <p className="font-body text-base ml-2">30% City Streets
              </p>
            </div>
            <div className="flex pb-2">
              <div>
                <svg className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z"/>
                </svg>
                <span className="font-body text-base ml-2">About 7 miles
                </span>
              </div>
            </div>
            <div className="flex pb-2">
              <div>
                <svg className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M16.32 7.1A8 8 0 1 1 9 4.06V2h2v2.06c1.46.18 2.8.76 3.9 1.62l1.46-1.46 1.42 1.42-1.46 1.45zM10 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM7 0h6v2H7V0zm5.12 8.46l1.42 1.42L10 13.4 8.59 12l3.53-3.54z"/>
                </svg>
                <span className="font-body text-base ml-2">About 3 hours
                </span>
              </div>
            </div>
            <div className="flex pb-2">
              <div>
                <svg className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm1-5h1a3 3 0 0 0 0-6H7.99a1 1 0 0 1 0-2H14V5h-3V3H9v2H8a3 3 0 1 0 0 6h4a1 1 0 1 1 0 2H6v2h3v2h2v-2z"/></svg>
                <span className="font-body text-base ml-2">$65 per person
                </span>
              </div>
            </div>


            <div className="flex items-center justify-center text-center pt-8 pb-6">
              <div>
                {/* <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white font-semibold no-underline leading-none font-title uppercase tracking-wide  whitespace-no-wrap py-4 px-8 flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-500 fb-entity-config-id-5181 fb-domain-go.theflybook.com fb-protocol-https">
                  Book Now
                </button>  */}
                <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide pointer-events-none cursor-not-allowed" disabled>
                    Closed until 2025
                </button> 
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-xs m-2 rounded flex-auto overflow-hidden shadow-lg flex flex-col mt-2">
          <img className="w-full flex-grow" src={EmeraldCity} alt="A photo of the Emerald City tour which features iconic landmarks like The Space Needle, Amazon HQ1 and the Ballard locks"></img>
          <div className="px-6 py-4 flex-grow">
            <div className="font-bold text-xl mb-2 uppercase font-title">Emerald City Tour</div>
            <p className="text-grey-darker text-base leading-normal font-body pt-4 pr-4 pb-4">
            Want to get to know the city? This tour packs in iconic landmarks, history, and culture with frequent stops for stories and fantastic views, at spots like The Space Needle and Amazon HQ1. See and hear what makes Seattle one of the fastest growing and most well loved destinations in the United States!
            </p>
          </div>

          <div className="p-8 bg-grey-lightest flex-grow">
            <div className="flex pb-2">
              <svg 
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 20 20">
                  <path d="M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z"/>
              </svg>
              <p className="font-body text-base ml-2">Difficulty: <span className="text-orange font-bold">Moderate</span>
              </p>
            </div>
            <div className="flex pb-2">
              <svg 
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 20 20">
                  <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41L9 10.41z"/>
              </svg>
              <p className="font-body text-base ml-2">Start Time: <span className="font-bold">11AM</span> 
              </p>
            </div>
            <div className="flex pb-2">
              <svg 
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 20 20">
                  <path d="M0 0l20 8-8 4-2 8z"/>
              </svg>
              <p className="font-body text-base ml-2">80% Bike Path
              </p>
            </div>
            <div className="flex pb-2">
              <svg 
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 20 20">
                  <path d="M2 14v-3H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1l4-7h8l4 7h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3zm13.86-5L13 4H7L4.14 9h11.72zM5.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"/>
              </svg>
              <p className="font-body text-base ml-2">20% City Streets
              </p>
            </div>
            <div className="flex pb-2">
              <div>
                <svg 
                  className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 20 20">
                    <path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z"/>
                </svg>
                <span className="font-body text-base ml-2">About 15 miles
                </span>
              </div>
            </div>
            <div className="flex pb-2">
              <div>
                <svg 
                  className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 20 20">
                    <path d="M16.32 7.1A8 8 0 1 1 9 4.06V2h2v2.06c1.46.18 2.8.76 3.9 1.62l1.46-1.46 1.42 1.42-1.46 1.45zM10 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM7 0h6v2H7V0zm5.12 8.46l1.42 1.42L10 13.4 8.59 12l3.53-3.54z"/>
                </svg>
                <span className="font-body text-base ml-2">About 3.5 hours
                </span>
              </div>
            </div>
            <div className="flex pb-2">
              <div>
                <svg 
                  className="fill-current text-grey h-3 self-center"
                  xmlns="http://www.w3.org/2000/svg" 
                  viewBox="0 0 20 20">
                    <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm1-5h1a3 3 0 0 0 0-6H7.99a1 1 0 0 1 0-2H14V5h-3V3H9v2H8a3 3 0 1 0 0 6h4a1 1 0 1 1 0 2H6v2h3v2h2v-2z"/>
                  </svg>
                <span className="font-body text-base ml-2">$70 per person
                </span>
              </div>
            </div>


            <div className="flex items-center justify-center text-center  pt-8 pb-6">
              <div>
                {/* <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white font-semibold no-underline leading-none font-title uppercase tracking-wide  whitespace-no-wrap py-4 px-8 flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-500 fb-entity-config-id-5182 fb-domain-go.theflybook.com fb-protocol-https">
                  Book Now
                </button>   */}
                <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide pointer-events-none cursor-not-allowed" disabled>
                    Closed until 2025
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-xs m-2 rounded flex-auto overflow-hidden shadow-lg flex flex-col mt-2">
          <img className="w-full flex-grow" src={ScenicTour} alt="A photo of the bike tour on trail through trees."></img>
          <div className="px-6 py-4 flex-grow">
            <div className="font-bold text-xl mb-2 uppercase font-title">Lake Washington Scenic Ride</div>
            <p className="text-grey-darker text-base leading-normal font-body pt-4 pr-4 pb-4">
              Want to get some miles in? This 40 mile route showcases the natural beauty of Lake Washington’s north end. Your knowledgeable guide not only keeps you on route, but points out landmarks and shares stories of the Pacific Northwest’s natural and cultural history along the way!
            </p>
          </div>

          <div className="p-8 bg-grey-lightest flex-grow">
            <div className="flex pb-2">
              <svg
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M15 9a3 3 0 0 0 3-3h2a5 5 0 0 1-5.1 5 5 5 0 0 1-3.9 3.9V17l5 2v1H4v-1l5-2v-2.1A5 5 0 0 1 5.1 11H5a5 5 0 0 1-5-5h2a3 3 0 0 0 3 3V4H2v2H0V2h5V0h10v2h5v4h-2V4h-3v5z" />
              </svg>
              <p className="font-body text-base ml-2">Difficulty: <span className="text-orange font-bold">Moderate</span> to <span className="text-red font-bold">Challenging</span>
              </p>
            </div>
            <div className="flex pb-2">
              <svg
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-1-7.59V4h2v5.59l3.95 3.95-1.41 1.41L9 10.41z" />
              </svg>
              <p className="font-body text-base ml-2">Start Time: <span className="font-bold">11AM</span>
              </p>
            </div>
            <div className="flex pb-2">
              <svg
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M0 0l20 8-8 4-2 8z" />
              </svg>
              <p className="font-body text-base ml-2">90% Bike Path
              </p>
            </div>
            <div className="flex pb-2">
              <svg
                className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20">
                <path d="M2 14v-3H1a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1l4-7h8l4 7h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1h-1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1H5v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-3zm13.86-5L13 4H7L4.14 9h11.72zM5.5 14a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm9 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
              </svg>
              <p className="font-body text-base ml-2">10% City Streets
              </p>
            </div>
            <div className="flex pb-2">
              <div>
                <svg
                  className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20">
                  <path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z" />
                </svg>
                <span className="font-body text-base ml-2">About 40 miles
                </span>
              </div>
            </div>
            <div className="flex pb-2">
              <div>
                <svg
                  className="fill-current text-grey h-3 self-center" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20">
                  <path d="M16.32 7.1A8 8 0 1 1 9 4.06V2h2v2.06c1.46.18 2.8.76 3.9 1.62l1.46-1.46 1.42 1.42-1.46 1.45zM10 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12zM7 0h6v2H7V0zm5.12 8.46l1.42 1.42L10 13.4 8.59 12l3.53-3.54z" />
                </svg>
                <span className="font-body text-base ml-2">About 4.5 hours
                </span>
              </div>
            </div>
            <div className="flex pb-2">
              <div>
                <svg
                  className="fill-current text-grey h-3 self-center"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20">
                  <path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm1-5h1a3 3 0 0 0 0-6H7.99a1 1 0 0 1 0-2H14V5h-3V3H9v2H8a3 3 0 1 0 0 6h4a1 1 0 1 1 0 2H6v2h3v2h2v-2z" />
                </svg>
                <span className="font-body text-base ml-2">$80 per person
                </span>
              </div>
            </div>


            <div className="flex items-center justify-center text-center  pt-8 pb-6">
              <div>
                {/* <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white font-semibold no-underline leading-none font-title uppercase tracking-wide  whitespace-no-wrap py-4 px-8 flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-500 fb-entity-config-id-8721 fb-domain-go.theflybook.com fb-protocol-https">
                  Book Now
                </button> */}
                <button className="rounded bg-brand-orange hover:bg-orange-dark text-lg text-brand-white no-underline leading-none font-thing brand-whitespace-no-wrap py-4 px-8 h-12 shadow font-body uppercase tracking-wide pointer-events-none cursor-not-allowed" disabled>
                    Closed until 2025
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
);

export default Tours;



// WEBPACK FOOTER //
// ./src/components/Tours/index.js